import _ from 'lodash';
import { flattenArray } from './dataFormatUtils';
import { timeSeriesXAxis } from '../../../shared/constants/constants';
/* eslint-disable complexity */
export function getNormalizationFunction(min, max) {
    return (value) => {
        if (max - min === 0 || value > max) {
            return 1;
        }

        if (value < min) {
            return 0;
        }

        return (value - min) / (max - min);
    };
}
/* eslint-enable complexity */

export function getMinMaxValues(data, valueRange) {
    if (!_.isEmpty(valueRange)) {
        return valueRange;
    }
    const allValues = flattenArray(_.values(data));
    return { min: _.min(allValues), max: _.max(allValues) };
}

export function keyDataPointsByTimestamp(dataPoints) {
    return _.keyBy(dataPoints, (dataPoint) => dataPoint[timeSeriesXAxis]);
}

export function getOrderedDefaultedDataPoints(
    bucketTimes,
    pointsByTimestamp,
    metric
) {
    return bucketTimes.map((bucketTime) =>
        pointsByTimestamp[bucketTime]
            ? pointsByTimestamp[bucketTime][metric]
            : 0
    );
}

export function formatHeatmapMetricSeries(
    bucketTimes,
    metricSeries,
    metric,
    groupBy
) {
    return _(metricSeries)
        .groupBy((x) => x[groupBy])
        .mapValues((groupedPoints) => {
            const pointsByTimestamp = keyDataPointsByTimestamp(groupedPoints);

            return getOrderedDefaultedDataPoints(
                bucketTimes,
                pointsByTimestamp,
                metric
            );
        })
        .value();
}
